<template>
  <div class="d-flex flex-column align-center text-center gr-4">
    <a
      class="d-inline-flex"
      :href="reverseFull({ name: 'lpu', args: [lpu.town.translit, lpu.translit] })"
    >
      <LpuLogoPicture
        v-if="ff_update_lpu_logo"
        img-class="object-fit-scale-down rounded"
        contain
        width="240"
        height="80"
        :files="getLpuLogoImageFiles(lpu)"
        :alt="t('Аватар', options)"
      />
      <img
        v-else
        class="object-fit-scale-down rounded"
        :alt="t('Аватар', options)"
        :src="getLpuAvatarUrl({ lpu })"
        width="240"
        height="80"
      >
    </a>
    <div class="d-flex flex-column justify-center">
      <a
        :href="reverseFull({ name: 'lpu', args: [lpu.town.translit, lpu.translit] })"
        class="text-subtitle-1 text-decoration-none primary--text mb-1"
      >
        {{ transDynamic(lpu, `name,${languageIso},${needTranslate}`) }}
      </a>
      <span class="text-body-2">
        {{ transDynamic(lpu.town, `name,${languageIso},${needTranslate}`) }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import I18NextVue from 'i18next'
import transDynamic from 'djanjucks/filters/transDynamic'
import type { ContextStore } from 'src/components/pages/profile/lpus/register/index/types'
import useURLStore from 'src/store/useURLStore'
import useContextStore from 'src/store/useContextStore'
import getLpuAvatarUrl, { getLpuLogoImageFiles } from 'src/utils/getLpuAvatarUrl'
import LpuLogoPicture from 'src/components/common/LpuLogoPicture/LpuLogoPicture.vue'

const { t, language } = I18NextVue
const options = { ns: language }

const { context }: ContextStore = useContextStore()
const needTranslate = context.need_translate
const languageIso = context.current_language?.iso ?? ''
const ff_update_lpu_logo = computed(() => Boolean(context.request.feature_flags.ff_update_lpu_logo))

defineProps<{
  lpu: NonNullable<ContextStore['context']['subject']>
}>()

const { reverseFull } = useURLStore()
</script>

<style lang="scss" scoped>
.object-fit-scale-down {
  object-fit: scale-down;
}

:deep(img) {
  object-fit: scale-down;
}
</style>
